// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: '海新能科招商', // Will update name in navigation menu (Branding)
    // eslint-disable-next-line global-require
    // appLogoImage: require('@/assets/images/logo/logo.svg'), // Will update logo in navigation menu (Branding)
    // eslint-disable-next-line global-require
    appLogoImage: require('@/assets/images/logo/logo.png'), // Will update logo in navigation menu (Branding)
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: true,
    enableScrollToTop: true,
  },
}

export const $urlConfig = {
  // url 请求地址
  // apiBaseURL: 'https://beilun.myyll.com/adminapi',
  // baseUrl: 'https://beilun.myyll.com/',

  // apiBaseURL: 'https://zsapi.ht-itc.com/adminapi',
  // baseUrl: 'https://zsapi.ht-itc.com/',

  apiBaseURL: 'https://www.haixinnengke.com/adminapi',
  baseUrl: 'https://www.haixinnengke.com/',
}

export const $fileUploadConfig = {
  // wss 地址
  wsSocketUrl: '',
  // 单文件导入接口地址
  fileUrlSingle: $urlConfig.apiBaseURL + '/file/uploadFile',
  // 多文件导入接口地址
  fileUrlMutiple: $urlConfig.apiBaseURL + '/file/upload',
}
